export const ACCESS_TOKEN = 'access_token'

export const SIDE_COLLAPSED = 'side_collapsed'
export const TOGGLE_MOBILE_TYPE = 'is_mobile'
export const TOGGLE_NAV_THEME = 'nav_theme'
export const TOGGLE_LAYOUT = 'layout'
export const TOGGLE_FIXED_HEADER = 'fixed_header'
export const TOGGLE_FIXED_SIDEBAR = 'fixed_sidebar'
export const TOGGLE_CONTENT_WIDTH = 'content_width'
export const TOGGLE_COLOR = 'color'
export const TOGGLE_WEAK = 'weak'
export const TOGGLE_MULTI_TAB = 'multi_tab'
export const APP_LANGUAGE = 'app_language'

export const LOGIN_USERNAME = 'login_username'
export const LOGIN_USERID = 'login_userId'
export const LOGIN_PASSWORD = 'login_password'
export const LOGIN_REMEMBERME = 'login_rememberme'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}

export const NAV_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
}

export const TABLE_SIZE = 'table_size'
export const TABLE_BORDERED = 'table_bordered'
export const HIDE_FOOTER = 'hide_footer'
